import React                                    from 'react';
import { Observe }                              from 'rewire-core';
import { DocumentDialog, IDocumentDialogProps } from '../schedule/DocumentDialog';
import { AccrualDialogModel } from './AccrualDialogModel';

class AccrualDialog extends React.Component<IDocumentDialogProps<AccrualDialogModel>> {
  constructor(props: IDocumentDialogProps<AccrualDialogModel>) {
    super(props);
  }

  render() {
    return <Observe render={() => (
      <DocumentDialog minWidth='245px' minHeight='405px' actions={this.props.model.accrualActions} {...this.props} />
    )} />;
  }
}

export default AccrualDialog;
